import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { ApiConstants } from './api.constant';

const AMAZON_AWS_HOST = 'amazonaws';
const AUTH_ENDPOINTS = [`/${ApiConstants.API_BASE_PATH}/${ApiConstants.API_GROUP_AUTH}/${ApiConstants.API_METHOD_LOGOUT}`];

export const relayterApiInterceptorFn: HttpInterceptorFn = (req, next) => {
    if (!shouldAugmentRequest(req.url)) {
        return next(req);
    }

    const router = inject(Router);
    const updatedRequest = req.clone({
        withCredentials: true,
        setHeaders: {
            [ApiConstants.RELAYTER_API_HEADERS.X_RELAYTER_AUTHORIZATION_TYPE]: 'admin'
        }
    });

    return next(updatedRequest).pipe(
        catchError((error: any) => {
            if (error.status === 401 && !isAuthEndpoint(req.url)) {
                const currentUrl = router.url || '/';
                if (!currentUrl.startsWith('/login')) {
                    router.navigate(['/login'], { queryParams: { redirectUrl: currentUrl } }).catch(() => undefined);
                }
            }
            return throwError(() => error);
        })
    );
};

function shouldAugmentRequest(url: string): boolean {
    if (!url) {
        return false;
    }

    if (url.includes(AMAZON_AWS_HOST)) {
        return false;
    }

    const normalizedApiServer = environment.API_SERVER?.replace(/\/$/, '');
    const isAbsoluteUrl = /^https?:\/\//i.test(url);

    if (isAbsoluteUrl) {
        return normalizedApiServer ? url.startsWith(normalizedApiServer) : false;
    }

    const apiPathPrefix = `/${ApiConstants.API_BASE_PATH}`;
    return url === apiPathPrefix || url.startsWith(`${apiPathPrefix}/`);
}

function isAuthEndpoint(url: string): boolean {
    if (!url) {
        return false;
    }

    return AUTH_ENDPOINTS.some((endpoint) => url.includes(endpoint));
}
